module.exports = __webpack_public_path__ + "images/icons/icon-grid-3-2dd4fbd7.svg";